import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageFilterStateService {
  storeFilter<T>(filter: T): void {
    localStorage.setItem('v2.pageFilter', JSON.stringify(filter));
  }

  getFilter<T>(): T | null {
    const filter = localStorage.getItem('v2.pageFilter');
    return filter ? JSON.parse(filter) as T : null;
  }

  clearFilter(): void {
    localStorage.removeItem('v2.pageFilter');
  }
}